import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import { AiOutlineArrowDown } from "react-icons/ai";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import MultiSelect from "../../../components/form/select/MultiSelect";
import PageTitle from "../../../components/partials/PageTitle";
import { getAllActiveRoles } from "../../../redux/slice/roles/roleSlice";
import {
  resetWorkflowStatus,
  submitWorkflow,
} from "../../../redux/slice/workflow/workflowSlice";

const CreateWorkflow = () => {
  const { active_roles } = useSelector((state) => state.role);
  const { isSuccess, isLoading } = useSelector((state) => state.workflow);
  const { user_permissions } = useSelector((state) => state?.auth?.user);
  const navigate = useNavigate();

  const breadcrumb = {
    from: {
      title: "workflow",
      link: "/admin/workflow",
    },
    current: {
      title: "create-workflow",
      link: null,
    },
  };

  const dispatch = useDispatch();

  const onSubmit = (values) => {
    let targetResorted = values?.target_roles.map((role) => ({
      role_name: role.value,
    }));
    let payload = {
      work_flow_name: values.workflow_name,
      target_roles: targetResorted,
    };
    dispatch(submitWorkflow(payload));
  };

  const {
    values,
    errors,
    touched,
    handleBlur,
    handleChange,
    handleSubmit,
    resetForm,
    getFieldProps,
    setFieldValue,
  } = useFormik({
    initialValues: {
      target_roles: [],
      workflow_name: "",
    },
    validate: (values) => {
      const errors = {};
      if (values.target_roles.length < 1) {
        errors.target_roles = "At least two target role is required";
      }
      if (!values?.workflow_name) {
        errors.workflow_name = "Workflow name is required";
      }
      return errors;
    },
    onSubmit,
  });

  const [draggedClauses, setDraggedClauses] = useState(values?.target_roles);

  // Function to handle the drag and rearrange
  const handleOnDragEnd = (result) => {
    if (!result.destination) return; // Item was dropped outside the list

    const items = Array.from(draggedClauses);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);
    setDraggedClauses(items);
    setFieldValue("target_roles", items);
  };

  useEffect(() => {
    dispatch(getAllActiveRoles());
  }, []);

  useEffect(() => {
    if (isSuccess) {
      navigate("/admin/workflow", { replace: true });
      dispatch(resetWorkflowStatus());
    }
  }, [isSuccess]);

  useEffect(() => {
    setDraggedClauses(values?.target_roles);
  }, [values.target_roles]);

  useEffect(() => {
    if (!user_permissions?.some(permission => permission.name === 'workflow module') || !user_permissions?.some(permission => permission.name === 'create workflow')) {
      navigate('/admin/dashboard')
    }

  }, [navigate, user_permissions])

  return (
    <>
      {/* page title */}
      <PageTitle title='Create Workflow' breadcrumb={breadcrumb} />
      {/* end page title */}
      <div className='row'>
        <div className='col-md-12'>
          <div className='card '>
            <div className='card-body'>
              <div className='border border-1 rounded-1 p-2'>
                <form
                  className='workflow-form mt-3 ms-4 row'
                  onSubmit={handleSubmit}
                >
                  <div className='col-md-6'>
                    <div className='mb-3'>
                      <label htmlFor='workflow-name'>Workflow Name</label>
                      <input
                        type='text'
                        id='workflow-name'
                        name='workflow_name'
                        onChange={handleChange}
                        onBlur={handleBlur}
                        className={`form-control form-control-sm mt-1 ${
                          errors?.workflow_name &&
                          touched?.workflow_name &&
                          "is-invalid"
                        }`}
                        placeholder='Enter name'
                      />
                      {errors?.workflow_name && touched?.workflow_name && (
                        <span className='text-danger'>
                          {errors.workflow_name}
                        </span>
                      )}
                    </div>
                    <div className='mb-3'>
                      <label htmlFor='target-role'>Target Role</label>
                      <MultiSelect
                        isError={errors?.target_roles && touched?.target_roles}
                        name='target_roles'
                        id='target-role'
                        field={{ ...getFieldProps("target_roles") }}
                        data={active_roles?.roles?.map((item, i) => ({
                          label: item?.name,
                          value: item?.name,
                        }))}
                        defaultValue={values?.target_roles}
                        onChange={setFieldValue}
                        onBlur={() => {
                          handleBlur({ target: { name: "target_roles" } });
                        }}
                        errors={errors}
                        touched={touched}
                      />
                    </div>
                    <DragDropContext onDragEnd={handleOnDragEnd}>
                      <Droppable droppableId='droppable'>
                        {(provided) => (
                          <div
                            ref={provided.innerRef}
                            {...provided.droppableProps}
                            className='mt-3'
                            style={{ width: "fit-content" }}
                          >
                            {draggedClauses?.map((item, i) => (
                              <Draggable
                                key={i}
                                draggableId={item.value}
                                index={i}
                              >
                                {(provided) => (
                                  <div
                                    ref={provided.innerRef}
                                    {...provided.draggableProps}
                                    {...provided.dragHandleProps}
                                    key={item.value}
                                    className='d-flex justify-content-between align-items-center py-1 px-1'
                                  >
                                    <div className=''>
                                      <p
                                        className=' m-0 px-2 bg-info text-white text-capitalize shadow-hover'
                                        style={{
                                          width: "fit-content",
                                          paddingTop: "3px",
                                          paddingBottom: "3px",
                                        }}
                                      >
                                        {item.label}
                                      </p>
                                      {draggedClauses?.length !== i + 1 && (
                                        <AiOutlineArrowDown
                                          size={22}
                                          className='mt-1 text-center'
                                        />
                                      )}
                                    </div>

                                    <div className='d-flex align-items-center gap-2'>
                                      <span
                                        data-bs-toggle='modal'
                                        data-bs-target='#add_clause'
                                      >
                                        {/* <MdEdit onClick={() => setEditData(item)} /> */}
                                      </span>
                                      {/* <span>
                    <MdRemoveRedEye className='text-primary' />
                  </span> */}
                                      {/* <span>
                    <MdClear
                      className='text-danger'
                      onClick={() => dispatch(deleteClause(item?.clause_id))}
                    />
                  </span> */}
                                    </div>
                                  </div>
                                )}
                              </Draggable>
                            ))}
                            {provided.placeholder}{" "}
                            {/* This should be placed here */}
                          </div>
                        )}
                      </Droppable>
                    </DragDropContext>
                  </div>
                  <div className='my-4 '>
                    <button
                      type='submit'
                      className='btn btn-sm btn-primary text-white'
                      disabled={
                        !values.workflow_name ||
                        values.target_roles?.length < 1 ||
                        isLoading
                      }
                    >
                      Create
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CreateWorkflow;
